import React from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { useWebFramed } from "../../../hooks/useWebFramed";
import GlobalSearch from "../Search/GlobalSearch/GlobalSearch";
import { StyledContainer, StyledModal } from "./HotelSearchModalHelpers";
import { IHotelSearchModalProps } from "./HotelSearchModalProps";

const HotelSearchModal: React.FC<IHotelSearchModalProps> = (props) => {
  const isWebFramed = useWebFramed();
  const location = props.location || window.location;
  const [_findHotelClicked, setFindHotelClicked] = React.useState(false);

  const handleOnHide = () => {
    props.onHide();
  };

  const handleOnSearchSubmit = () => {
    setFindHotelClicked(true); // so that we can differentiate if user clicked on find hotel or simply closed the modal
    handleOnHide();
  };

  return (
    <StyledModal
      {...props}
      onHide={handleOnHide}
      aria-label="Hotel Search"
      className="modal-fullscreen"
    >
      <Modal.Header closeButton={!isWebFramed}>
        <Modal.Title className="w-100 text-center my-4 logo">{""}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <StyledContainer>
          <Row>
            <Col className="justify-content-center">
              <GlobalSearch
                location={location}
                isSearchModal={true}
                isHotelPage={props.isHotelPage}
                isBrandHotelSearchModal={true}
                onSearchSubmit={handleOnSearchSubmit}
              />
            </Col>
          </Row>
        </StyledContainer>
      </Modal.Body>
    </StyledModal>
  );
};

export default HotelSearchModal;
